// extracted by mini-css-extract-plugin
export default {"label_spec":"patientSearch_label_spec__tvPHj","search_icon_image":"patientSearch_search_icon_image__32evF","pl40":"patientSearch_pl40__gdkGi"};